interface Config {
  atmBaseUrl: string;
}

const config: Config = {
  atmBaseUrl: process.env.REACT_APP_ATM_BASE_URL || "http://atm.docker/atm",
};

export default config;
